import { useQuery } from '@tanstack/react-query'
import { api } from '@astro/api'

export const CONSULTATION_TYPE_LABELS = { video: 'Video call', phone: 'Phone call', inperson: 'In person' }

/**
 * Raju Maharaj's gemstone consultation offer (GET /gemstone-consultation):
 * { is_enabled, rate, duration, start_time, end_time, consultation_types,
 * astrologer }. `rate` is the price of one whole session, set in the admin
 * panel / his dashboard — never computed here. Returns null until loaded.
 */
export function useGemstoneOffer() {
  const { data, isPending, isError } = useQuery({
    queryKey: ['gemstone-offer'],
    queryFn: () => api.bookings.gemstoneOffer(),
    staleTime: 60 * 1000,
    retry: false,
    select: (res) => res?.data ?? null,
  })
  return { offer: data ?? null, isPending, isError }
}
